/**
 * Centralized Ezoic configuration and placeholder IDs.
 * These come from Ezoic Ads → Ad Positions → Placeholders.
 * Note: sidebar_* are desktop-only.
 */

export const EZOIC = {
  placements: {
    // Sidebar placements (Desktop only)
    sidebarFloating2: 914, // "sidebar_floating_2"
    sidebarFloating1: 913, // "sidebar_floating_1"
  },
} as const

export type EzoicPlacementKey = keyof typeof EZOIC.placements
